import { Logo } from "../Logo";
import { Mail } from "lucide-react";
import { useScrollAnimation } from "../../hooks/useScrollAnimation";

export const Footer = () => {
  const [footerRef, footerVisible] = useScrollAnimation({ threshold: 0.3 });

  return (
    <footer 
      ref={footerRef}
      className="py-12 px-[5%] border-t border-[#1e1e1e]" 
      data-testid="footer"
      style={{
        opacity: footerVisible ? 1 : 0,
        transition: "opacity 0.6s ease-out",
      }}
    >
      <div className="max-w-content mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div 
            className="flex items-center gap-3"
            style={{
              opacity: footerVisible ? 1 : 0,
              transform: footerVisible ? "translateX(0)" : "translateX(-20px)",
              transition: "opacity 0.6s ease-out 0.1s, transform 0.6s ease-out 0.1s",
            }}
          >
            <Logo muted />
            <span className="text-[0.9rem] text-[#6b7280]">Veranda</span>
          </div>

          <div 
            className="flex items-center gap-6"
            style={{
              opacity: footerVisible ? 1 : 0,
              transform: footerVisible ? "translateX(0)" : "translateX(20px)",
              transition: "opacity 0.6s ease-out 0.1s, transform 0.6s ease-out 0.1s",
            }}
          >
            <a
              href="mailto:hello@veranda-ai.com"
              className="text-[#6b7280] hover:text-white transition-colors flex items-center gap-2 text-[0.9rem]"
              data-testid="footer-email"
            >
              <Mail className="w-4 h-4" />
              hello@veranda-ai.com
            </a>
          </div>
        </div>

        <div 
          className="mt-8 pt-8 border-t border-[#1e1e1e] text-center"
          style={{
            opacity: footerVisible ? 1 : 0,
            transition: "opacity 0.6s ease-out 0.2s",
          }}
        >
          <p className="text-[0.8rem] text-[#6b7280]">
            © 2026 Veranda AI. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
